module.exports = __webpack_public_path__ + "static/media/icon_logo.e4099f51.svg";